import React from "react";

const TitleAlt = ({ children }) => (
  <h3 className="title-alt text-center">{children}</h3>
);

export default TitleAlt;
